import { NgComponentOutlet } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AppNotification } from "../app-notification.model";
import { getNotificationRegistryEntry } from "../notification-registry";

@Component({
  selector: "app-notification-host",
  standalone: true,
  imports: [NgComponentOutlet],
  template: `
    @if (registryEntry) {
      <ng-container
        *ngComponentOutlet="
          registryEntry.component;
          inputs: componentInputs
        "
      />
    }
  `,
})
export class NotificationHostComponent {
  @Input({ required: true }) notification!: AppNotification;
  @Output() activate = new EventEmitter<string>();
  @Output() dismiss = new EventEmitter<string>();

  get registryEntry() {
    return getNotificationRegistryEntry(this.notification.eventType);
  }

  get componentInputs(): Record<string, unknown> {
    return {
      notification: this.notification,
      onActivate: (notificationId: string) =>
        this.activate.emit(notificationId),
      onDismiss: (notificationId: string) => this.dismiss.emit(notificationId),
    };
  }
}
